
// @ts-nocheck


export const localeCodes =  [
  "en",
  "lt",
  "pl",
  "rs",
  "fr",
  "fl",
  "nl"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_764e8ede",
      load: () => import("#nuxt-i18n/764e8ede" /* webpackChunkName: "locale_en_46ts_764e8ede" */),
      cache: true
    }
  ],
  lt: [
    {
      key: "locale_lt_46ts_560f9b79",
      load: () => import("#nuxt-i18n/560f9b79" /* webpackChunkName: "locale_lt_46ts_560f9b79" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46ts_7f6d8747",
      load: () => import("#nuxt-i18n/7f6d8747" /* webpackChunkName: "locale_pl_46ts_7f6d8747" */),
      cache: true
    }
  ],
  rs: [
    {
      key: "locale_rs_46ts_c62a9e5b",
      load: () => import("#nuxt-i18n/c62a9e5b" /* webpackChunkName: "locale_rs_46ts_c62a9e5b" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46ts_ebc93d68",
      load: () => import("#nuxt-i18n/ebc93d68" /* webpackChunkName: "locale_fr_46ts_ebc93d68" */),
      cache: true
    }
  ],
  fl: [
    {
      key: "locale_fl_46ts_836e45d7",
      load: () => import("#nuxt-i18n/836e45d7" /* webpackChunkName: "locale_fl_46ts_836e45d7" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46ts_1aa986f0",
      load: () => import("#nuxt-i18n/1aa986f0" /* webpackChunkName: "locale_nl_46ts_1aa986f0" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/b41aeca5" /* webpackChunkName: "config_i18n_46config_46ts_b41aeca5" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        {
          path: "/var/www/app/i18n/locales/en.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "lt",
      language: "lt-LT",
      name: "Lithuanian",
      files: [
        {
          path: "/var/www/app/i18n/locales/lt.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      language: "pl-PL",
      name: "Polish",
      files: [
        {
          path: "/var/www/app/i18n/locales/pl.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "rs",
      language: "rs-RS",
      name: "Serbian",
      files: [
        {
          path: "/var/www/app/i18n/locales/rs.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      name: "French",
      files: [
        {
          path: "/var/www/app/i18n/locales/fr.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "fl",
      language: "fl-FL",
      name: "Flemish",
      files: [
        {
          path: "/var/www/app/i18n/locales/fl.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      language: "nl-NL",
      name: "Dutch",
      files: [
        {
          path: "/var/www/app/i18n/locales/nl.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "i18n/locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_locale",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/var/www/app/i18n/locales/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "lt",
    language: "lt-LT",
    name: "Lithuanian",
    files: [
      {
        path: "/var/www/app/i18n/locales/lt.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    language: "pl-PL",
    name: "Polish",
    files: [
      {
        path: "/var/www/app/i18n/locales/pl.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "rs",
    language: "rs-RS",
    name: "Serbian",
    files: [
      {
        path: "/var/www/app/i18n/locales/rs.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "French",
    files: [
      {
        path: "/var/www/app/i18n/locales/fr.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fl",
    language: "fl-FL",
    name: "Flemish",
    files: [
      {
        path: "/var/www/app/i18n/locales/fl.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    language: "nl-NL",
    name: "Dutch",
    files: [
      {
        path: "/var/www/app/i18n/locales/nl.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/